import { AgGridReact } from 'ag-grid-react';
import moment from "moment";
import notificationSVG from '../../asset/Images/notification-text.svg';
import { getAssetNotesTabDetails, getAssetNoteDetails} from '../../actions/assetNotestabAction';
import { getMultipleDocs, getDocumentdetails } from "../../actions/assetDocumentsActions";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import { DownloadDocument } from '../../../config/apiConfig';
import { sbaAxios } from '../../utils/sbaAxios';
import noDataAvailable from '../../../Images/noDataAvailable.svg';

export const RecentNoteTab = () => {

    //getAssetNotesTabDetails
    const params = useParams();
    const dispatch = useDispatch();
    const NotesTabDetails = useSelector(state => state.notesTabDetails.notesTab);
  
    const [showNotes, setShowNotes] = useState(false);
    const columnDef = [
        {
            headerName: '',
            field: 'ActivityId',
            maxWidth: 30,
            cellRenderer: (params) => {
                return <img src={notificationSVG} className='SBA_hand' alt="Notification" onClick={() => { dispatch(getAssetNoteDetails(params.value)); dispatch(getMultipleDocs(params.value)); setShowNotes(true) }} />;
            },
           
        },
        {
            tooltipValueGetter:(params) => (moment(params.value).format('MM/DD/YYYY')),
            field: "NoteDate", headerName: "Date",
            flex:1,
            valueFormatter: function (params) {
                return moment(params.value).format('MM/DD/YYYY');
            },
            cellStyle: {
                textAlign: 'left',
            }
        },
        {
            tooltipField: 'ActivityName', field: "ActivityName", headerName: "Description",
            cellStyle: {
                textAlign: 'left',
            },
            // maxWidth: 500,
            flex:2
        },];
    const gridOptions = {
        defaultColDef: {
            resizable: true,
            sortable: true,
            filter: true,
            flex: 1
        },
        rowHeight: 30,
    };
    const handleClose=()=>setShowNotes(false);
    return <>
        {/* <div className="ag-theme-alpine" style={{ width: '100%' }}>
            <AgGridReact columnDefs={columnDef} gridOptions={gridOptions} rowData={NotesTabDetails} />
        </div> */}
       
            {NotesTabDetails.length > 0 ?
                <> <div className="ag-theme-alpine" style={{ width: '100%', minHeight: '10px', textAlign: 'center' }}>  <AgGridReact
                    columnDefs={columnDef}
                    rowData={NotesTabDetails}
                    gridOptions={gridOptions}
                    domLayout='autoHeight'
                    enableBrowserTooltips={true}
                    defaultColDef={{resizable:true}}
                /> </div>
                </> : <><div className='d-flex w-100 my-4 h-100'>
                              <img src={noDataAvailable} alt='NO DATA AVAILABLE' className='m-auto' width={'30%'}/>
                              </div></>}
       
        <Modal
            show={showNotes}
            onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable w-100" >
                <div class="modal-content p-2 overflow-auto " >
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="NotesModalLabel">Recent Notes
                        </h1>
                        <button type="button" class="btn-close" onClick={handleClose}
                            aria-label="Close"></button>
                    </div>
                    <form action="#">
                        <div class="modal-body ">
                            <h6 class="fw-medium fs-6 mt-3">
                            </h6>
                            <NotesTabPopUp />
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    </>
}
export const NotesTabPopUp = () => {
  
    const noteDetails = useSelector(state => state.notesTabDetails.noteDetails);
    const noteDate = moment(noteDetails?.ActivityDate).format('MM-DD-YYYY');
    const Documents = useSelector(state => state.mutipleDocuments.mutipleDocuments);
   
    const pdfview = (documentId, documentName) => {
        const encodedDocumentId = btoa(documentId.toString());
       // const urls = DownloadDocument + encodedDocumentId;
        try {
            sbaAxios({ url: DownloadDocument + encodedDocumentId, responseType: 'blob' }).then((response) => {
                var downloadLink = document.createElement('a');
                downloadLink.href = URL.createObjectURL(response);
                downloadLink.download = documentName;
                downloadLink.click();  
            })
        }
        catch (error) {
            console.error('Error opening PDF:', error);
        }
    }



    return( 
        <>{Documents.length === 0 ? <label>No Documents Available </label> :
            Documents.map(item => {
                return (
                    <div class="card-body p-0">
                        <div class="row p-3 border-bottom  m-0">
                            <div class="col-11 left">
                                <span>{item.DocumentName}</span>
                            </div>
                            {
                                <div class="col-1 text-sm-end fw-medium">
                                    <span className='SBA_hand'>{item.DocumentExtension === ".pdf" || "pdf" ? <i class="far fa-file-pdf" style={{ color: "red" }} onClick={() => pdfview(item.DocumentId,item.DocumentName)}></i> : ""} </span>
                                </div>
                            }
                        </div>
                    </div>

                );
            })
        }
        <div className='row mb-2'>
            <div className='col-md-4'> <div className='fw-medium'>Owner :</div><div className='fw-medium'>{noteDetails?.ActivitySource}</div></div>
            <div className='col-md-4'><div className='fw-medium'>Created BY :</div><div className='fw-medium'>{noteDetails?.ActivitySource}</div></div>
            <div className='col-md-4'><div className='fw-medium'>Date Created :</div><div className='fw-medium'>{noteDate}</div></div>
        </div>
        <div className='fw-medium '>Subject :</div>
        <div className='fw-medium mb-2'>{noteDetails?.ActivityName}</div>
        <div className='fw-medium '>Body :</div>
        <div className='detail p-2' id='notesTabContent' style={{ overflowY: 'scroll', height: "50vh" }} dangerouslySetInnerHTML={{ __html: noteDetails.ActivityDescriptionHTML }}>
         </div>
        </>
    )
}